import { Divider } from "@mui/material";
import type { ChangeEvent } from "react";
import { defineMessages, useIntl } from "react-intl";

import { Checkbox } from "@/components/Checkbox/Checkbox";
import { HOTEL_CLASSES } from "@/features/hotels/utils/constants";

const starLabels = defineMessages<number>({
  0: {
    defaultMessage: "Unrated",
    description: "Hotel class filter option: unrated properties",
  },
  1: {
    defaultMessage: "1 star",
    description: "Hotel class filter option: 1-star properties",
  },
  2: {
    defaultMessage: "2 stars",
    description: "Hotel class filter option: 2-star properties",
  },
  3: {
    defaultMessage: "3 stars",
    description: "Hotel class filter option: 3-star properties",
  },
  4: {
    defaultMessage: "4 stars",
    description: "Hotel class filter option: 4-star properties",
  },
  5: {
    defaultMessage: "5 stars",
    description: "Hotel class filter option: 5-star properties",
  },
});

type Props = {
  selectedClasses?: number[];
  userManuallySelectedAllClasses: boolean;
  onChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    option: number,
  ) => void;
};

export const HotelClassFilter = ({
  selectedClasses = [],
  userManuallySelectedAllClasses,
  onChange,
}: Props) => {
  const intl = useIntl();

  const areAllClassesSelected = selectedClasses.length === HOTEL_CLASSES.length;

  return (
    <ul>
      {HOTEL_CLASSES.map((option) => (
        <li key={option}>
          <label className="flex w-full items-center justify-between py-2">
            <span className="font-medium text-text-primary">
              {intl.formatMessage(starLabels[option] ?? starLabels[0])}
            </span>
            <Checkbox
              checked={
                selectedClasses?.includes(option) &&
                (userManuallySelectedAllClasses || !areAllClassesSelected)
              }
              onChange={(e) => onChange(e, e.target.checked, option)}
              density="compact"
            />
          </label>
          <Divider />
        </li>
      ))}
    </ul>
  );
};
